"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recurrenceTypes = void 0;
var recurrenceTypes = {
  NONE: "None",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  YEARLY: "Yearly"
};
exports.recurrenceTypes = recurrenceTypes;